import {
	Component,
	OnInit,
	ViewChildren,
	OnDestroy,
	QueryList,
} from '@angular/core';
import { User } from 'src/shared/api';
import { FormConfig } from 'src/shared/form-models/form-cva.component';
import { FormControlName, FormBuilder, FormGroup } from '@angular/forms';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { select, Store } from '@ngrx/store';
import { shareReplay, takeUntil, filter } from 'rxjs/operators';
import { preventFlicker } from 'src/shared/utilities/custom-rxjs-operators';
import { AdminUsersPartialState } from '../+state/admin-user.reducer';
import { touchAllControls } from 'src/shared/utilities/utility-functions';
import * as AdminUserSelectors from '../+state/admin-user.selectors';
import * as AdminUserActions from '../+state/admin-user.actions';
import { Subject } from 'rxjs';

const adminUserDetailsFormConfig: Partial<FormConfig<User>> = {
	id: [''],
	email: [''],
	firstName: [''],
	loginName: [''],
	lastName: [''],
	fieldWorker: [''],
	phoneNumber: [''],
	roles: [''],
};

@Component({
	templateUrl: './admin-user.component.html',
})
export class AdminUserDetailComponent
	extends SelfDestruct
	implements OnInit, OnDestroy
{
	@ViewChildren(FormControlName) childControls: QueryList<FormControlName>;
	private _invalidSubmission = new Subject<number>();

	form = this.fb.group(adminUserDetailsFormConfig) as FormGroup;

	readonly isLoading$ = this.store.pipe(
		select(AdminUserSelectors.getDetailLoadingStatus),
		shareReplay(1)
	);

	readonly isSaving$ = this.store.pipe(
		select(AdminUserSelectors.getIsSaving),
		preventFlicker(1000)
	);

	readonly invalidSubmission$ = this._invalidSubmission.asObservable();

	constructor(
		private readonly store: Store<AdminUsersPartialState>,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.store
			.pipe(
				select(AdminUserSelectors.getSelectedAdminUser),
				filter(Boolean),
				takeUntil(this.destroyed)
			)
			.subscribe((formValue) => {
				this.form.patchValue(formValue, { emitEvent: false });
				this.form.get('email').disable();
				this.form.get('firstName').disable();
				this.form.get('lastName').disable();
				this.form.get('phoneNumber').disable();
				this.form.get('roles').disable();
			});
	}

	save(stay = false) {
		if (this.form.valid) {
			const formValue = this.form.getRawValue();
			this.store.dispatch(
				AdminUserActions.saveRequested({
					shouldStayOnPage: stay,
					formValue,
				})
			);
		} else {
			touchAllControls(this.childControls);
			this._invalidSubmission.next(new Date().getTime());
		}
	}

	ngOnDestroy() {
		this.store.dispatch(AdminUserActions.adminUserDetailDestroyed());
		super.ngOnDestroy();
	}
}
